<template lang="pug">
.page 
    .ctl-bar
        a-radio-group(button-style="solid" @change="handleTypeChange" default-value="CS" v-model="computedType")
            a-radio-button(value="CS") 全部A股
            a-radio-button(value="CS50") 指数50
            a-radio-button(value="CS300") 指数300
            a-radio-button(value="CS500") 指数500
            a-radio-button(value="CS1000") 指数1000
            a-radio-button(value="CS2000") 指数2000
            a-radio-button(value="Convertible") 可转债

        a-button(@click="exportData" type="primary" icon="export" style="margin-left: 10px") 导出

        a-button(@click="exportStockCbondData" type="primary" icon="export" style="margin-left: 10px") 导出股票+可转债

    a-table(:columns="columns"
        rowKey="order_book_id"
        size="small"
        bordered
        :rowClassName="getRowClass"
        :pagination="{pageSize: 20, total: total, showTotal: (total) => `总计 ${total}`, current: this.current, onChange: handlePageChange}"
        :dataSource="instruments")
</template>

<script>
import axios from 'axios';
import _ from 'lodash';

export default {
    data() {
        return {
            instruments: [],
            type: 'CS',
            indexName: '',
            total: 0,
            current: 1,
            priceTimer: null,
            columns: [
                {
                    dataIndex: 'order_book_id',
                    title: '代码'
                },
                {
                    title: '名称',
                    dataIndex: 'symbol'
                },
                {
                    title: '行业',
                    dataIndex: 'industry_name',
                },
                {
                    title: '板块',
                    dataIndex: 'board_type',
                },
                {
                    title: '现价',
                    dataIndex: 'last',
                },
                {
                    title: '涨幅%',
                    dataIndex: 'pctChange',
                }
            ]
        }
    },
    mounted() {
        this.getInstruments();
        this.startPriceRefresh();
    },
    beforeDestroy() {
        this.stopPriceRefresh();
    },
    methods: {
        getInstruments() {
            let route = 'allInstruments?type=' + this.type;

            if (this.indexName) route = route + '&indexName=' + this.indexName;

            this.$api.request('GET', route)
                .then(res => {
                    this.instruments = res.data;
                    this.total = this.instruments.length;
                    this.addPriceInfo();
                });
        },
        async getPrices(codes) {
            const res = await axios.post('/prices', {
                codes,
                fields: ['last', 'preClosePrice'],
            });
            return res.data;
        },
        async addPriceInfo() {
            const pageSize = 20;
            const start = (this.current - 1) * pageSize;
            const end = start + pageSize;
            const pageInstruments = this.instruments.slice(start, end);

            const codes = pageInstruments.map(i => i.order_book_id);
            const priceData = await this.getPrices(codes);

            const priceMap = _.keyBy(priceData, 'inst');

            this.instruments = this.instruments.map(i => {
                const price = priceMap[i.order_book_id];
                if (price) {
                    i.last = price.last;
                    const preClose = price.preClosePrice;
                    if (preClose && preClose > 0) {
                        const pctValue = (price.last - preClose) / preClose * 100;
                        i.pctChange = `${pctValue.toFixed(2)}%`;
                        i.pctChangeNum = pctValue;
                    } else {
                        i.pctChange = '0.00%';
                        i.pctChangeNum = 0;
                    }
                }
                return i;
            });
            
        },
        handlePageChange(page) {
            this.current = page;
            this.addPriceInfo();
        },
        getRowClass(record) {
            if (record.pctChangeNum > 0) {
                return 'stock-up';
            } else if (record.pctChangeNum < 0) {
                return 'stock-down';
            }
            return '';
        },
        handleTypeChange(e) {
            const value = e.target.value;
            if (value.startsWith('CS')) {
                this.type = 'CS';

                if (value === 'CS') {
                    this.indexName = '';
                } else {
                    this.indexName = value.replace('CS', '');
                }
            }
            else if (value == 'Convertible') {
                this.type = 'Convertible';
                this.indexName = '';
            }
            
            this.current = 1;
            this.getInstruments();
        },
        isTradingTime() {
            const now = new Date();
            const day = now.getDay();
            // 周末不交易
            if (day === 0 || day === 6) return false;

            const hours = now.getHours();
            const minutes = now.getMinutes();
            const time = hours * 60 + minutes;

            // 上午 9:30-11:30 (570-690)
            // 下午 13:00-15:00 (780-900)
            return (time >= 570 && time < 690) || (time >= 780 && time < 900);
        },
        startPriceRefresh() {
            this.priceTimer = setInterval(() => {
                if (this.isTradingTime()) {
                    this.addPriceInfo();
                }
            }, 3000);
        },
        stopPriceRefresh() {
            if (this.priceTimer) {
                clearInterval(this.priceTimer);
                this.priceTimer = null;
            }
        },
        async exportStockCbondData() {
            // 获取股票数据 (CS)
            const stockRes = await this.$api.request('GET', 'allInstruments?type=CS');
            const stocks = stockRes.data.map(i => ({ ...i, type: '股票' }));

            // 获取可转债数据 (Convertible)
            const cbondRes = await this.$api.request('GET', 'allInstruments?type=Convertible');
            const cbonds = cbondRes.data.map(i => ({ ...i, type: '可转债' }));

            // 合并数据
            const allInstruments = [...stocks, ...cbonds];

            // 获取所有代码的价格数据
            const allCodes = allInstruments.map(i => i.order_book_id);
            const priceData = await this.getPrices(allCodes);
            const priceMap = _.keyBy(priceData, 'inst');

            // 整合价格和涨跌幅
            const exportInstruments = allInstruments.map(i => {
                const exportItem = { ...i };
                const price = priceMap[i.order_book_id];
                if (price) {
                    exportItem.last = price.last;
                    const preClose = price.preClosePrice;
                    if (preClose && preClose > 0) {
                        const pctValue = (price.last - preClose) / preClose * 100;
                        exportItem.pctChange = `${pctValue.toFixed(2)}%`;
                    } else {
                        exportItem.pctChange = '0.00%';
                    }
                } else {
                    exportItem.last = exportItem.last || '';
                    exportItem.pctChange = '0.00%';
                }
                return exportItem;
            });

            // 生成CSV
            const headers = ['order_book_id', 'symbol', 'type', 'industry_name', 'board_type', 'last', 'pctChange'];
            const csvContent = [
                headers.join(','),
                ...exportInstruments.map(row => headers.map(h => {
                    const val = row[h];
                    if (val === null || val === undefined) return '';
                    const str = String(val);
                    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                        return `"${str.replace(/"/g, '""')}"`;
                    }
                    return str;
                }).join(','))
            ].join('\n');

            // 下载文件
            const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = `instruments_股票可转债_${new Date().toISOString().slice(0, 10)}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        async exportData() {
            const allCodes = this.instruments.map(i => i.order_book_id);
            const priceData = await this.getPrices(allCodes);
            const priceMap = _.keyBy(priceData, 'inst');

            const exportInstruments = this.instruments.map(i => {
                const exportItem = { ...i };
                const price = priceMap[i.order_book_id];
                if (price) {
                    exportItem.last = price.last;
                    const preClose = price.preClosePrice;
                    if (preClose && preClose > 0) {
                        const pctValue = (price.last - preClose) / preClose * 100;
                        exportItem.pctChange = `${pctValue.toFixed(2)}%`;
                    } else {
                        exportItem.pctChange = '0.00%';
                    }
                } else {
                    exportItem.last = exportItem.last || '';
                    exportItem.pctChange = exportItem.pctChange || '0.00%';
                }
                return exportItem;
            });

            const headers = ['order_book_id', 'symbol', 'industry_name', 'board_type', 'last', 'pctChange'];
            const csvContent = [
                headers.join(','),
                ...exportInstruments.map(row => headers.map(h => {
                    const val = row[h];
                    if (val === null || val === undefined) return '';
                    const str = String(val);
                    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                        return `"${str.replace(/"/g, '""')}"`;
                    }
                    return str;
                }).join(','))
            ].join('\n');

            const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = `instruments_${this.type}${this.indexName}_${new Date().toISOString().slice(0, 10)}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    },
    computed: {
        computedType() {
            if (this.type == 'CS') {
                if (this.indexName == '50') return 'CS50';
                else if (this.indexName == '300') return 'CS300';
                else if (this.indexName == '500') return 'CS500';
                else if (this.indexName == '1000') return 'CS1000';
                else if (this.indexName == '2000') return 'CS2000';
                else return 'CS';
            }
            return this.type;
        }
    }
}
</script>

<style lang="less" scoped>
::v-deep .ant-table-small {
    .ant-table-cell {
        padding: 4px 8px;
        font-size: 13px;
    }

    .ant-table-thead > tr > th {
        padding: 6px 8px;
    }
}
</style>